import axiosIns from '@/plugins/axios'
import { ApiList } from '@/api/v2/types/json-api'

export interface ExpenseAttrs {
  id: number
  date: string
  amount: number
  expensePrimaryLabelName: string
  expenseSecondaryLabelName: string
  expenseTertiaryLabelName: string
  expenseQuaternaryLabelName: string
  isNonCash: boolean
}

export type ExpenseListResponse = ApiList<ExpenseAttrs, 'expenses'>

export async function getExpenses(
  params: {
    start_date: string
    end_date: string
  },
): Promise<ExpenseAttrs[]> {
  const res = await axiosIns.get<ExpenseListResponse>(
    '/v2/data_export/expenses',
    { params },
  )

  return res.data.data.data.map(r => r.attributes)
}
